import { ChangeEventHandler, useContext } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'

import { RowsSelect } from './rows-select.component'
import { PaginationContext } from './context/pagination.context'

import { countTotalPages } from '../../common/utils/count-pages.util'
import { useStyles } from './styles'

interface IPaginationButtonsProps {
  buttonsOnly?: boolean
}

const PaginationButtonsCompnent = ({ buttonsOnly }: IPaginationButtonsProps) => {
  const classes = useStyles({ buttonsOnly })
  const pagination = useContext(PaginationContext)

  if (!pagination) return null
  const { count, page, rowsPerPage, setPage, setRowsPerPage, isShown = true, withAll } = pagination

  const handleChangeRowsPerPage: ChangeEventHandler<HTMLSelectElement> = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleNextClick = () => {
    if (page === totalPages) return

    setPage((prevPage) => prevPage + 1)
  }
  const handlePrevClick = () => {
    if (page === 0) return

    setPage((prevPage) => prevPage - 1)
  }

  const totalPages = countTotalPages(count, rowsPerPage)

  if (!isShown) {
    return null
  }

  return (
    <Grid className={classes.paginationContainer}>
      <Grid className={classes.paginationWrapper}>
        {!buttonsOnly && (
          <Grid className={classes.paginationTextWrapper}>
            <Typography className={classes.paginationText}>Showing&nbsp;</Typography>
            <RowsSelect
              withAll={withAll}
              handleChange={handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
            />
            <Typography className={classes.paginationText}>
              &nbsp;of&nbsp;{count}&nbsp;entities
            </Typography>
          </Grid>
        )}
        <Grid className={classes.paginationButtonWrapper}>
          <Button
            className={classes.paginationButton}
            variant="contained"
            disabled={page === 0}
            onClick={handlePrevClick}
          >
            <ChevronLeftIcon />
          </Button>
          <Button
            className={classes.paginationButton}
            variant="contained"
            disabled={page === totalPages}
            onClick={handleNextClick}
          >
            <ChevronRightIcon />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

const PaginationButtons = ({ buttonsOnly }: IPaginationButtonsProps) => {
  return <PaginationButtonsCompnent buttonsOnly={buttonsOnly} />
}

export { PaginationButtons, PaginationContext }
